import React from "react";
import {connect} from "react-redux";
import {logout} from "../../../redux/actions/auth/loginActions";
import {
    BrowserView, isMobile,
    MobileView,
} from "react-device-detect";
import Menu from "components/Web/Headers/Menu"
import * as Icon from "react-feather";
import {ListGroup} from 'react-bootstrap';
import {NavLink as RNavLink} from "reactstrap";
import MobileNavbar from "./MobileMenuRender/Navbar";
import logo1 from "../../../assets/img/logo/logo1.webp";
import PersonIcon from "@material-ui/icons/Person";
import {GetRequest} from "../../request";
import Notify from "components/Baran/noty/notify";
import {history} from "../../../history";
import {Link, NavLink, useNavigate} from "react-router-dom";
import {Roles} from "../../roles/ProjectRole";
import {
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalHeader, Row,
    UncontrolledDropdown
} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {ContextLayout} from "../../../layouts/PageLayout";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import {CloseSharp, Fingerprint, WhatsApp} from "@material-ui/icons";
import android from "../../../assets/img/logo/logo1.webp";
import play from "../../../assets/img/downloads/androidPlay.png";
import bazaar from "../../../assets/img/downloads/bazaar.png";
import myket from "../../../assets/img/downloads/myket.png";
import apple from "../../../assets/img/icons/apple.png";
import sibiranilogobanner from "../../../assets/img/downloads/sibiranilogobanner.png";
import IappsBadgeGray from "../../../assets/img/downloads/IappsBadgeGray.png";
import anardoniBadgeDarkPersian from "../../../assets/img/downloads/anardoniBadgeDarkPersian.png";
import {HiOutlineUser} from 'react-icons/hi'
import logo from '../../../assets/img/logo/logoLine.webp'
import {AiFillHome, AiOutlineArrowUp, AiOutlineClose, AiOutlineFileDone} from 'react-icons/ai'
import {HiOutlinePhone} from 'react-icons/hi'
import {TbDeviceMobile} from 'react-icons/tb'
import scrollWindowTop from "../../../utility/scrollWindowTop";
import {RiSearch2Line} from "react-icons/ri"
import {FaInstagram} from "react-icons/fa";
import roban from '../../../assets/img/backgrounds/roban.png'

import {
    ChevronsLeft,
    ChevronsRight,
    Instagram,
    Mail,
    MapPin,
    Phone,
    User
} from "react-feather";
import {Tooltip} from "@material-ui/core";
import data from "../../../assets/data/configs/storeConfig.json";
import {BiSearchAlt} from "react-icons/bi";
import {IoClose, IoPhonePortraitOutline} from "react-icons/io5";


let searchDelay = 0;

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            doesShowSearchBar: false,
            searchValue: "",
            position: 0,
            modal: false,
            searchUrl: "/api/home/web/search",
            courses: [],
            course_categories: [],
            articles: [],
            article_categories: [],
            searchBox: false,
            dropdownUser: false,
            support: false,
            modal_download: false,
            mobileClick: false,
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.state.position) {
            const listenToScroll = () => {
                const winScroll =
                    document.body.scrollTop || document.documentElement.scrollTop

                const height =
                    document.documentElement.scrollHeight -
                    document.documentElement.clientHeight

                const scrolled = winScroll / height

                this.setState(scrolled)
            }
            window.addEventListener('scroll', listenToScroll)
            return () => window.removeEventListener('scroll', listenToScroll);
        }

    }

    getData = () => {
        GetRequest(`${this.state.searchUrl}?s=${this.state.searchValue}`,
            {
                'Authorization': this.props.user.token,
            }, true).then((response) => {
            let result = response.data;
            if (result.ok) {
                result = result.data;
                this.setState({
                    courses: result.courses,
                    course_categories: result.course_categories,
                    articles: result.articles,
                    article_categories: result.article_categories
                })
            }
        }).catch(function (error) {
            Notify('error', 'top-right', "خطایی رخ داده است");
        });
    }

    showSearchBar = () => {
        this.setState({
            doesShowSearchBar: !this.state.doesShowSearchBar
        })
    }

    searchHandler = (e) => {
        clearTimeout(searchDelay)
        this.setState({
            searchValue: e.target.value,
            closeList: false
        })
        if (this.state.searchValue.length > 0) {
            searchDelay = setTimeout(async () => {
                this.getData();
            }, 800);
        }
    }

    openSearchBox = () => {
        this.setState({
            searchBox: !this.state.searchBox,
        })
    }
    handleSearchClick = () => {
        history.push("/courses?s=" + this.state.searchValue);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            history.push("/courses?s=" + this.state.searchValue);
        }
    }

    closeResults = () => {
        this.setState({
            closeList: !this.state.closeList,
        })
    }

    goToPanel = () => {
        if (this.props.user.roles.includes(Roles.Student))
            history.push('/panel/my-courses')
        else if (this.props.user.roles.includes(Roles.Teacher))
            history.push('/panel/teacher-courses')
        else
            history.push('/panel/dashboard')
    }

    exit = () => {
        if (this.props.user.token)
            this.props.logout()
    }


    render() {
        const searchbar =
            <>
                {
                    <div className="d-flex search-field">
                        {this.state.searchValue ?
                            <ListGroup className={this.state.closeList ? "d-none" : "search-results"}
                                       onMouseLeave={() => this.closeResults()}>
                                {this.state.courses.length > 0 ?
                                    <>
                                        <label className="d-flex justify-content-between">
                                            <span>دوره</span>
                                            <NavLink to={"/search?s=" + this.state.searchValue}
                                                     className="bg-transparent border-0">مشاهده بیشتر</NavLink>
                                        </label>
                                        {this.state.courses.map((item, index) => {
                                                return (
                                                    <ListGroup.Item
                                                        className={`w-100 ${this.state.course_categories.length - 1 === index && "border-b"}`}>
                                                        <NavLink to={"/course/" + item.slug} className="w-100 d-block"
                                                                 key={item.course_id}>
                                                            <div className="d-flex align-items-flex">
                                                                <div className="image-wrapper">
                                                                    <img
                                                                        src={item.image}
                                                                        alt={item.name}
                                                                        title={item.name}/>
                                                                </div>
                                                                <span
                                                                    className="my-auto ml-1">{item.name}</span>
                                                            </div>
                                                        </NavLink>
                                                    </ListGroup.Item>
                                                )
                                            }
                                        )}
                                    </> : null
                                }
                                {this.state.articles.length > 0 ?
                                    <>
                                        <label className="d-flex justify-content-between">
                                            <span>مقاله ها</span>
                                            <NavLink to={"/search?s=" + this.state.searchValue}
                                                     className="bg-transparent border-0">مشاهده بیشتر</NavLink>
                                        </label>
                                        {this.state.articles.map((item, index) => {
                                                return (
                                                    <ListGroup.Item
                                                        className={`w-100 ${this.state.course_categories.length - 1 === index && "border-b"}`}>
                                                        <NavLink to={"/article/" + item.slug} className="w-100 d-block"
                                                                 key={item.article_id}>
                                                            <div className="d-flex align-items-flex">
                                                                <div className="image-wrapper">
                                                                    <img
                                                                        src={item.image}
                                                                        alt={item.title}
                                                                        title={item.title}/>
                                                                </div>
                                                                <span
                                                                    className="my-auto ml-1">{item.title}</span>
                                                            </div>
                                                        </NavLink>
                                                    </ListGroup.Item>
                                                )
                                            }
                                        )}
                                    </> : null
                                }
                            </ListGroup> : null
                        }
                    </div>
                }
            </>

        const search =
            <div
                className={`header-template-one-left-search-box ${this.state.searchBox && "header-template-one-left-search-box-open"} d-flex align-items-center`}>
                <input
                    className="search-box"
                    type="text"
                    placeholder="جستجو..."
                    onKeyDown={this.handleKeyDown}
                    onMouseEnter={() => this.closeResults()}
                    onChange={(e) => this.searchHandler(e)}
                    aria-label="Input group example"
                    aria-describedby="btnGroupAddon2"
                />
                <div>
                    <IoClose size={18} onClick={this.openSearchBox} />
                </div>
            </div>;


        const login = this.props.user.token ?
            <>
                <ul className="nav navbar-nav navbar-nav-user w-100">
                    <UncontrolledDropdown tag="li"
                                          className="dropdown-user nav-item text-center">
                        <DropdownToggle tag="a"
                                        className="nav-link dropdown-user-link">
                            <div className="user-nav d-sm-flex d-none">
                            </div>
                            <span data-tour="user" onClick={() => isMobile && this.goToPanel()}>
                                                      <img
                                                          src={this.props.user.photo}
                                                          className="round"
                                                          height="40"
                                                          width="40"
                                                          alt="avatar"
                                                      />
                                                    </span>
                        </DropdownToggle>
                        <DropdownMenu left>
                            <DropdownItem
                                tag="a"
                                href="#"
                                onClick={this.goToPanel}>
                                <Icon.User size={14} className="ml-50"/>
                                <span className="align-middle">
                                                            پنل
                                                        </span>
                            </DropdownItem>
                            <DropdownItem divider/>
                            <DropdownItem
                                tag="a"
                                onClick={this.exit}>
                                <Icon.Power size={14} className="ml-50"/>
                                <span className="align-middle">
                                                            <FormattedMessage id="Logout"/>
                                                        </span>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </ul>
            </>
            :
            <ContextLayout.Consumer>
                {context => {
                    return (
                        <>
                            <div className="header-template-one-left-login-button"
                                 onClick={() => context.showLoginModal(true)}>
                                <HiOutlineUser size={25}/>
                            </div>
                        </>
                    )
                }
                }
            </ContextLayout.Consumer>

        let Moderate = false;

        if (this.props.user.roles)
            Moderate = this.props.user.roles.includes(Roles.Moderate);

        /*        <BrowserView>
                    <div className="header-web w-100">
                        <div className="header">

                            <div className="down-header  d-flex justify-content-between mx-0">
                                <div className='header-menu position-relative '>
                                    <div className=''>
                                        <div>

                                        </div>

                                    </div>






                                </div>
                            </div>
                        </div>
                    </div>
                </BrowserView>

                */
        return (
            <>
                <div className="fixed-menu">
                    <BrowserView className={"header-template-one"}>
                        <div className="container-custome d-flex align-items-center justify-content-between">
                            <div className="header-template-one-right">
                                <div className='header-template-one-right-logo'>
                                    <Link to={"/"}>
                                        <img src={logo} width={120}/>
                                    </Link>
                                </div>
                                <div className="header-template-one-right-menu">
                                    <Menu/>
                                </div>
                            </div>
                            <div className="header-template-one-left">
                                <div className={`header-template-one-left-search`}>
                                    <BiSearchAlt size={25} onClick={this.openSearchBox}/>
                                </div>
                                <div className="header-template-one-left-login">
                                    {login}
                                </div>
                                <a href={`tel:${data.mobile[0]}`} className='header-template-one-left-phone'>
                                    <Phone size={20}/>
                                    <span>{data.mobile[0]}</span>
                                </a>
                            </div>
                        </div>
                    </BrowserView>
                    <MobileView>
                        <div className='header-template-one-phone'>
                            <div className="">
                                <MobileNavbar
                                    logo={
                                        logo
                                    }
                                    search={
                                        searchbar
                                    }
                                />
                            </div>
                            <div className='header-logo'>
                                <Link to={"/"}>
                                    <img src={
                                        logo
                                    } width={100}/>
                                </Link>
                            </div>
                            <div>
                                {login}
                            </div>
                        </div>
                    </MobileView>
                    {
                        search
                    }
                </div>
                <MobileView>
                    <div className='bottom-menu-template-one'>
                        <Link to={"/"}
                              className={`bottom-menu-template-one-item ${window.location.pathname === "/" && "bottom-menu-template-one-item-active"}`}
                        >
                            <AiFillHome/>
                            <p>صفحه اصلی </p>
                        </Link>

                        <div className={`bottom-menu-template-one-item`}
                             onClick={this.openSearchBox}>
                            <RiSearch2Line/>
                            <p> جستجو </p>
                        </div>

                        <Link to='/courses'
                              className={`bottom-menu-template-one-item ${window.location.pathname === "/courses" && "bottom-menu-template-one-item-active"}`}
                        >
                            <span> <AiOutlineFileDone/></span>
                            <p>دوره ها</p>
                        </Link>
                        <Link to='/contact-us'
                              className={`bottom-menu-template-one-item ${window.location.pathname === "/contact-us" && "bottom-menu-template-one-item-active"}`}
                        >
                            <span> <IoPhonePortraitOutline/></span>
                            <p>ارتباط با ما</p>
                        </Link>

                        <div className='scroll-to-top' onClick={scrollWindowTop}>
                            <a><AiOutlineArrowUp/></a>
                        </div>
                    </div>
                </MobileView>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth,
        UI: state.UI
    }
}
export default connect(mapStateToProps, {
    logout
})(Header)
